import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Col, Row,Table } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";

const UserLogs = () => {
  const navigate = useNavigate(); // Use useNavigate hook for navigation

   ///////////////////////////////////////////////////////////
   const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
   function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1');
      return [];
    }
  }

  const pageName = 'UserLog';
  const actionsForPage = getActionsForPage(pageName);

///////////////////////////////////
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filters, setFilters] = useState({
    from: '',
    to: '',
    user: '',
    action: ''
  });

  useEffect(() => {
    fetchLogs();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [filters, logs]);

  const fetchLogs = async () => {
    try {
      const res = await axios.get('https://subk.education.com.ly/back/api/user-process-logs');
      setLogs(res.data);
    } catch (error) {
      console.error("Error fetching logs:", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let result = [...logs];

    if (filters.from) {
      result = result.filter(log => log.ActionDate >= filters.from);
    }

    if (filters.to) {
      result = result.filter(log => log.ActionDate <= filters.to);
    }

    if (filters.user) {
      result = result.filter(log => log.user?.name?.includes(filters.user));
    }

    if (filters.action) {
      result = result.filter(log => log.Action?.includes(filters.action));
    }

    setFilteredLogs(result);
  };

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
   <div className="container-fluid   p-4" >
        <Row>
          <Col lg="12">
            <div className="card">
              <div className="card-header">
                <h4 className="heading mb-0">سجلات المستخدم</h4>
                 
              </div>
      {/* Filters */}
              <div className="row" style={{ display: 'flex', margin: '20px' }}>
        <div className="col-md-3">
          <label>من التاريخ:</label>
          <input
            type="date"
            className="form-control"
            name="from"
            value={filters.from}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-3">
          <label>إلى التاريخ:</label>
          <input
            type="date"
            className="form-control"
            name="to"
            value={filters.to}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-3">
          <label>المستخدم:</label>
          <input
            type="text"
            className="form-control"
            name="user"
            value={filters.user}
            onChange={handleChange}
            placeholder="اكتب اسم المستخدم"
          />
        </div>
        <div className="col-md-3">
          <label>الإجراء:</label>
          <input
            type="text"
            className="form-control"
            name="action"
            value={filters.action}
            onChange={handleChange}
            placeholder="مثلاً: تحديث"
          />
        </div>
      </div>

      {/* Table */}
      {loading ? (
        <div>جارٍ التحميل...</div>
      ) : filteredLogs.length === 0 ? (
        <div className='m-3'>لا توجد سجلات مطابقة</div>
      ) : (
        <div  style={{ overflowX: 'auto' , maxHeight:'400px'}} className="table-responsive m-3" id="invoiceDiv">
            
                         <Table responsive className="table-bordered table-striped table-hover">
                         <thead  style={{                  borderColor: "#0D0C0",
}}className="thead-primary">
              <tr>
                <th>#</th>
                <th>الإجراء</th>
                <th style={{
                  width: '250px',
                  maxWidth: '250px',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  overflowWrap: 'break-word'
                }}>الوصف</th>
                <th>التاريخ</th>
                <th>الوقت</th>
                <th>المستخدم</th>
              </tr>
            </thead>
            <tbody               style={{ borderColor: "#0D0C0",}}   
>
              {filteredLogs.map((log, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{log.Action}</td>
                  <td style={{
                    width: '250px',
                    maxWidth: '250px',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',

                    overflowWrap: 'break-word'
                  }}>{log.Description}</td>
                  <td>{log.ActionDate}</td>
                  <td>{log.ActionTime}</td>
                  <td>{log.user?.name || 'غير معروف'}</td>
                </tr>
              ))}
            </tbody>
          </Table>

        </div>
      )}
    </div>
    </Col></Row>
    </div>
  );
};

export default UserLogs;
